// extracted by mini-css-extract-plugin
export default {"title":"Home_title__XLxL1","subtitle":"Home_subtitle__Kke44"};